// src/components/ui/ScrollToTop/ScrollToTop.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Automatically scrolls to the top of the page when the route changes
 * Place this component inside the Router in App.tsx
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior, // instant for immediate scroll, or 'smooth' for animated
    });
  }, [pathname]); // Runs whenever the pathname changes

  return null; // This component doesn't render anything
};

export default ScrollToTop;